import { Command } from '@heidi/design-system/command';
import { atom } from 'jotai';
import { useRouter } from 'next/router';
import { OrganizationSideBarCommandList } from './side-nav-list/list';

export const SettingsListCommandInputValueAtom = atom('');

export const OrganizationSideBar = () => {
  const router = useRouter();

  return (
    <Command
      value={router.pathname}
      shouldFilter={false}
      className="flex size-full flex-col gap-4 px-3 sm:w-[200px]"
    >
      <OrganizationSideBarCommandList />
    </Command>
  );
};
